export const NAME = 'viewActivity'
export const RECEIPT_NAME = 'viewActivityReceipt'

export const ActivityStatus = {
  PENDING: 0,
  STARTED: 1,
  FINISHED: 2,
  CANCELLED: 3,
}

export const PaymentStatus = {
  INITIALIZED: 0,
  AUTHORIZED: 1,
  CAPTURED: 2,
  CANCELLED: 3,
}

export default NAME



// WEBPACK FOOTER //
// ../source/views/ViewActivity/constants.js